import { useEffect, useRef } from 'react';
import Link from 'next/link';

import { useFocusTrap } from '@ui/Modal/hooks/useFocusTrap';
import { useEscapePress } from '@ui/Modal/hooks/useEscapePress';

import { CloseIcon } from '@components/icons/CloseIcon';

export function SubscriptionExceededBanner({ closable = false, onClose }) {
  /**
   * @type {React.MutableRefObject<HTMLDivElement>}
   */
  const overlayRef = useRef();
  /**
   * @type {React.MutableRefObject<HTMLDivElement>}
   */
  const modalRef = useRef();

  useFocusTrap(modalRef, true);
  useEscapePress(modalRef, closable, onClose);

  useEffect(() => {
    const overlay = overlayRef.current;

    if (closable) {
      overlay?.addEventListener('click', onClose);
    }

    return () => {
      overlay?.removeEventListener('click', onClose);
    };
  }, [closable, onClose]);

  return (
    <>
      <div className="overlay" ref={overlayRef}></div>

      <div className="bannerModal" ref={modalRef}>
        {closable && (
          <button
            type="button"
            className="absolute -top-[12px] -right-[12px] z-[1000] p-[6px] bg-wtf-persianRed rounded-full"
            onClick={onClose}
          >
            <CloseIcon size={24} color="#fff" />
          </button>
        )}

        <img
          src="/characters/sumi.jpg"
          alt="Banner Image"
          className="bannerImage"
        />
        <h2 className="bannerHeader" style={{ marginTop: 0, marginBottom: 0 }}>
          Want more? 😳
        </h2>
        <p className="bannerText">
          Add extra messages and photos to your active subscription easily!
        </p>
        <Link href="/plans" className="bannerButton">
          Upgrade
        </Link>
      </div>
    </>
  );
}
